import { HttpParams } from "@angular/common/http";
import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Client } from "app/client/client.model";
import { ClientRepository } from "app/client/client.repository";
import { NotifyService } from "app/notify/notify.service";
import { TOAST } from "app/notify/toast/toast-type.enum";
import { PaginationList } from "app/shared/grid/pagination-list.model";
import { Subscription } from "rxjs";
import { QuoteRepository } from "../quote.repository";

@Component({
  selector: "app-quote-create",
  templateUrl: "./quote-create.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./quote-create.component.scss"],
})
export class QuoteCreateComponent implements OnInit {
  protected quoteRepository = inject(QuoteRepository);
  protected clientRepository = inject(ClientRepository);
  protected notifyService = inject(NotifyService);
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);

  private clientRef: string;
  private quoteRef: string;
  public subscription = new Subscription();

  ngOnInit() {
    this.getDetailsFromRoute();
    this.doCreate();
  }

  private getDetailsFromRoute() {
    this.clientRef = this.route.params["value"]["clientRef"];
    this.quoteRef = this.route.params["value"]["quoteRef"];
  }

  private doCreate(): void {
    // 1. get client
    const params = new HttpParams({
      fromObject: {
        "criteria[ref]": this.clientRef,
      },
    });
    this.subscription.add(
      this.clientRepository
        .paginatedList(params)
        .subscribe((clients: PaginationList<Client>) => {
          if (clients.items.length === 0) {
            this.notifyService.toast(
              TOAST.ERROR,
              `Can't find an account with ref: ${this.clientRef}`,
            );
            this.router.navigate(["quote/0"]);
          } else {
            // 2. Create QUote
            this.quoteRepository
              .createQuote({
                clients: [clients.items[0].getId()],
                ref: this.quoteRef,
              })
              .subscribe((quote) => {
                // 3. redirect
                this.router.navigate([
                  "quote/" + quote.getId() + "/" + quote.getDisplayId(),
                ]);
              });
          }
        }),
    );
  }
}
